const HOUR_MS = 60 * 60 * 1000;

export const KPI_RANGE_PRESETS = [
  { key: "1h", label: "1h", durationMs: HOUR_MS },
  { key: "6h", label: "6h", durationMs: 6 * HOUR_MS },
  { key: "24h", label: "24h", durationMs: 24 * HOUR_MS },
  { key: "7d", label: "7d", durationMs: 7 * 24 * HOUR_MS },
  { key: "30d", label: "30d", durationMs: 30 * 24 * HOUR_MS },
];

export const createRelativeRange = (durationMs, now = Date.now()) => ({
  from: now - durationMs,
  to: now,
});

export const createPreviousRange = ({ from, to }) => {
  const duration = to - from;
  return {
    from: from - duration,
    to: from,
  };
};

export const isValidTimeRange = ({ from, to }) => (
  Number.isFinite(from) && Number.isFinite(to) && from < to
);

export const toLocalDateTimeInput = (timestamp) => {
  const date = new Date(timestamp);
  const localTime = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return localTime.toISOString().slice(0, 16);
};

export const fromLocalDateTimeInput = (value) => new Date(value).getTime();

export const formatKpiRange = ({ from, to }) => {
  const formatter = new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

  return `${formatter.format(new Date(from))} - ${formatter.format(new Date(to))}`;
};